import { render, staticRenderFns } from "./WorkflowForm.vue?vue&type=template&id=dc0dcae8&scoped=true&"
import script from "./WorkflowForm.vue?vue&type=script&lang=js&"
export * from "./WorkflowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0dcae8",
  null
  
)

export default component.exports